(() => {
  const carousels = document.querySelectorAll('[data-calista-proof-carousel]');

  carousels.forEach((carousel) => {
    const viewport = carousel.querySelector('[data-proof-viewport]');
    const previous = carousel.querySelector('[data-proof-previous]');
    const next = carousel.querySelector('[data-proof-next]');

    if (!viewport || !previous || !next) return;

    const updateControls = () => {
      const maxScroll = viewport.scrollWidth - viewport.clientWidth;
      previous.disabled = viewport.scrollLeft <= 4;
      next.disabled = maxScroll <= 4 || viewport.scrollLeft >= maxScroll - 4;
    };

    const move = (direction) => {
      viewport.scrollBy({
        left: direction * viewport.clientWidth,
        behavior: 'smooth',
      });
    };

    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    viewport.addEventListener('scroll', updateControls, { passive: true });
    window.addEventListener('resize', updateControls);
    updateControls();
  });
})();
